module.exports = __webpack_public_path__ + "public/img/manbaoyou@2x.c171ace5.png";